import { useEffect, useState } from 'react';
import { LocalEmployeeRepository } from '@/modules/employees/infrastructure/repositories/LocalEmployeeRepository';

const repo = new LocalEmployeeRepository();

/**
 * Returns the NFC biometric id for an employee from the local Dexie cache.
 *
 * Used by AdminEmployeeDetailPage to determine whether the NFC delete button
 * should be enabled (id present) or disabled with a tooltip (id absent — device
 * not yet synced, so id_entity_biometric is unknown).
 *
 * Change: nueva-seccion-de-borrado-perfiles-en-administracion-empleados
 */
export function useNfcBiometricId(idPerson: number | null): {
  nfcBiometricId: number | null;
  isLoading: boolean;
} {
  const [nfcBiometricId, setNfcBiometricId] = useState<number | null>(null);
  const [isLoading, setIsLoading] = useState(idPerson !== null);

  useEffect(() => {
    if (idPerson === null) {
      setNfcBiometricId(null);
      setIsLoading(false);
      return;
    }

    let cancelled = false;
    setIsLoading(true);

    void repo.getNfcBiometricId(idPerson).then((id) => {
      if (!cancelled) {
        setNfcBiometricId(id);
        setIsLoading(false);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [idPerson]);

  return { nfcBiometricId, isLoading };
}
